export default __webpack_public_path__ + "static/media/github-getter.f7a50887.jpg";